import React, { useState, useEffect, useContext } from 'react';
import { UserDataContext } from '../../App';
import { Box, Typography } from '@mui/material';
import { ContentBox } from "../../libs/theme";
import { styled } from "@mui/material/styles";
import { useParams, useNavigate } from 'react-router-dom';
import REST from "../../libs/API";
import Sidebar from './Sidebar';
import OrderError from './OrderError';
import OrderVerify from './OrderVerify';
import OrderProcessing from './OrderProcessing';
import OrderDone from './OrderDone';
import PayByCrypto from './PayByCrypto';
import PayByBank from './PayByBank';
import PayByCoupon from './PayByCoupon';
import PayByWidget from './PayByWidget';
import PayByMerchant from './PayByMerchant';
import UpdateOrderRates from './UpdateOrderRates';
import RepeatOrder from './RepeatOrder';
import { getText } from '../../libs/utils';
import OrderAliasSaver from './OrderAliasSaver';
import OrderKYC from './OrderKYC';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  " > * ": {
    flex: 1
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column'
  }
}))

const LoadingBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  height: '100%',
  minHeight: '486px',
  ".dot-spin": {
    position: 'unset'
  }
}))

const PerformOrder = ({ setGreenScreen }) => {
  const userData = useContext(UserDataContext);
  const { orderHash } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState({});
  const [loading, setLoading] = useState(true);
  const [openRepeatDialog, setOpenRepeatDialog] = useState(false);

  useEffect(() => {
    !Object.keys(order).length && getStatus();

    if (order.nextState) {
      const { delay, callback, nextState } = order;
      setTimeout(() => {
        setOrder(nextState);
        callback();
        nextState.verification.statusId == 10 && window.scroll({ top: 0, behavior: 'smooth' }); // scroll to top when photo approved and payment screen opened
      }, delay);
    }

    window.statusCheck = setInterval(getStatus, 10000);

    return () => {
      clearInterval(window.statusCheck)
    };
  }, [order]);

  useEffect(() => {
    return () => {
      document.title = "CRYPSTER"
    };
  }, []);

  function getStatus(callback = () => { }) {
    if (orderHash) {
      REST.getOrderState(orderHash, userData.token).then(data => {

        if (data.success) {
          let newData = { ...data.data, timerOut: order.timerOut }

          document.title = getText('orPerformNumberHed') + " №" + data.data.id

          if (order.timerOut && !isTimeOut(newData.timerEnd)) { // If timer updated. Reset state
            newData.timerOut = false;
          } else if (!order.timerOut && isTimeOut(newData.timerEnd)) { // If time ended. Reset state
            newData.timerOut = true;
          }

          if (order.currentState !== JSON.stringify(newData)) { // Avoid same data
            delayState(orderStateDataMutation(newData), callback);
          }
        } else {
          if (data.status === 500) {
            // ???
          } else {
            console.warn("Order status error ", data.status);
            data.status === 401 && navigate("/")
            data.status === 404 && navigate("/404")
          }

        }
        setLoading(false);
        setGreenScreen(false);
      });
    } else {
      navigate("/");
    }
  }

  const isTimeOut = (timerEnd) => { return Math.floor((new Date(timerEnd) - new Date()) / 1000) < 0 };

  const delayState = (data, callback = () => { }) => {

    const commit = (delay = 0) => {
      if (delay == 0) { // Instant
        setOrder(data);
        callback();
      } else {
        setOrder({ ...order, nextState: data, delay, callback })
      }
      return null;
    }

    if (order.paymentStatus) { // Не первый запрос
      if (order.verification.statusId !== data.verification.statusId) { // Смена статуса верификации
        if (data.verification.statusId == 10) { // Верификация пройдена
          commit(5000);
        } else if (data.verification.statusId == 1) { // Ожидание проверки
          commit(2000);
        } else if (data.verification.statusId == 3) { // Ошибка
          commit(2000);
        }
        else if (order.verification.statusId == 10 && data.verification.isRequired == false) { // заявка оплачена
          commit(500);
        }
        else {
          commit(0);
        }
      } else if (order.paymentStatus.id !== data.paymentStatus.id) { // Статус поменялся
        if ([6, 71].includes(data.paymentStatus.id)) {
          commit(5000);
        }
        // else if([9].includes(data.paymentStatus.id)){
        //   commit(0); // Новая
        // } 
        else {
          commit(500);
        }
      } else {
        commit(0);
      }
    } else {
      commit(0);
    }
  }

  const orderStateDataMutation = (orderData) => {
    const mutatedOrderData = {
      ...orderData,
      verificationKYC: false,
      orderType: orderData.depositViewType.value,
      directReqsArray: orderData.deposits?.length > 0 ? orderData.deposits.map(deposit => ({
        ...deposit.tabs[0].outputs.reduce((acc, output) => ({ ...acc, [output.name]: output }), {}),
        notice: deposit.tabs[0].message,
        hash: deposit.hash,
        canSetPaid: deposit.canSetPaid,
        canUploadReceipt: deposit.canUploadReceipt,
      })) : undefined,
    };

    mutatedOrderData.directReqs = mutatedOrderData.directReqsArray?.[0];

    if (orderData.paymentStatus.id === 7 && mutatedOrderData.orderType === "CRYPT") {
      mutatedOrderData.paymentStatus.id = orderData.paymentStatus.isWaitingForConfirmation ? 71 : 70;
    }

    const paymentStatusId = orderData.paymentStatus.id;

    mutatedOrderData.orderState = (() => {
      if (paymentStatusId === undefined) return 0;
      if (orderData.verification && orderData.verification.isRequired && orderData.verification.statusId !== 10) {
        mutatedOrderData.paymentStatus.id = parseInt("8" + orderData.verification.statusId);
        return 1;
      }
      if ([1, 6, 7, 70, 71].includes(paymentStatusId)) return 3;
      if ([2, 4, 5, 8, 10].includes(paymentStatusId)) return 4;
      if ([3, 11].includes(paymentStatusId)) return 5;
      if (paymentStatusId === 9 && mutatedOrderData.directReqs) return 2;
      if (paymentStatusId === 14) return 2;
      if (paymentStatusId === 15) {
        mutatedOrderData.verificationKYC = true;
        return 1
      }; // custom state for "KYC pending"
      return 0;
    })();

    return mutatedOrderData;
  }

  const orderProps = {
    order,
    getStatus,
    handleTimeOut: () => setOrder({ ...order, timerOut: true })
  }

  return (<>
    {(order.canRepeat && openRepeatDialog) && <RepeatOrder closeDialog={() => setOpenRepeatDialog(false)} open={openRepeatDialog} order={order} />}
    <UpdateOrderRates open={order.recountRequired} order={order} onAccept={getStatus} />
    <OrderAliasSaver orderId={order.id} orderHash={order.code} />
    <ContentBox sx={{ minHeight: 486 }}>
      <Container>
        {loading || order.orderState === 0 ? <LoadingBox>
          <span className="dot-spin centered"></span>
          <Typography sx={{ color: 'secondary.main', fontSize: '12px' }}>{getText('ocrOrderLoading')}</Typography>
        </LoadingBox> : <>
          <Box>
            {order.orderState === 1 && order.verificationKYC && <OrderKYC {...orderProps} />}
            {order.orderState === 1 && !order.verificationKYC && <OrderVerify {...orderProps} />}

            {order.orderState === 2 && <>
              {(order.depositViewType.value === "CRYPT") && <PayByCrypto {...orderProps} />}
              {(order.depositViewType.value === "BANK") && <PayByBank {...orderProps} />}
              {(order.depositViewType.value === "WIDGET" || order.depositViewType.value === "EXTERNAL") && <PayByWidget {...orderProps} />}
              {(order.depositViewType.value === "CHECK") && <PayByCoupon {...orderProps} />}
              {(order.depositViewType.value === "PAYSYSTEM") && <PayByMerchant {...orderProps} />}
            </>}
            {order.orderState === 3 && <OrderProcessing order={order} />}
            {order.orderState === 4 && <OrderError order={order} getStatus={getStatus} />}
            {order.orderState === 5 && <OrderDone order={order} repeatOrder={() => setOpenRepeatDialog(true)} />}
          </Box>

          <Sidebar {...order} />
        </>}
      </Container>
    </ContentBox>
  </>
  )
}

export default PerformOrder